<template>
  <div class="footer">
    <div class="company">
      <ul class="message">
        <li>公司名称:深圳鲲鹏创信科技有限公司</li>
        <li>公司地址:深圳市龙岗区坂田街道坂田社区吉华路603号五层502</li>
        <li>服务热线:0755-2879 6402</li>
        <li>网址: https://www.kpcxai.com</li>
        <li>咨询QQ:554600654</li>
      </ul>
      <div class="code">
        <img class="codeImg" src="../assets/images/code.png" alt="code" />
        <div class="scanning">
          <p>扫描二维码</p>
          <p>关注微服务</p>
        </div>
      </div>
    </div>
    <div class="copyright">
      版权所有©2022 公司名称:深圳鲲鹏创信科技有限公司有限公司·<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2026092460号</a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang='less' scoped>
.footer {
  width: 100%;
  height: 14.0625rem;
  background-color: #1d1d1d;
  .company {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px #707070 solid;

    height: 10rem;
    width: 100%;
    .message {
      padding-top: 1.4375rem;
      margin-left: 27.875rem;
      width: 18.75rem;
      height: 100%;
      li {
        padding-bottom: .5625rem;
        font-size: .8125rem;
        font-family: PingFang SC;
        font-weight: 500;

        color: #ffffff;
      }
    }
    .code {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 27.8125rem;
      flex-direction: column;
      .codeImg {
        width: 6.25rem;
        height: 6.25rem;
      }
      .scanning {
        margin-top: .5625rem;
        p {
          font-size: .8125rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
        }
      }
    }
  }
  .copyright {
    margin-top: .9375rem;
    height: 3.125rem;
    line-height: 3.125rem;
    text-align: center;
    font-size: .6875rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #8a8a8a;
  }
}
</style>
